export default __webpack_public_path__ + "static/media/wulala.6fd0a6fc.png";